import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';

class GraphBarSvKarakter extends Component {
    constructor(props) {
        super(props);
        this.state = {            
            labels: ['Sangat Baik', 'Baik', 'Cukup'],
            datasets: [],
            title: ""
        }
    }

    componentDidMount() {        
        if(this.props.data !== undefined) { 
            if(this.props.tipe === 'SK') {
                this.setState({ labels: ['Unggul', 'Baik', 'Cukup'] })
            }
            const kab = this.props.data;
            const prov = this.props.dataProvinsi;
            let arrData = [
                {
                    label: 'CabDindik',
                    data: [kab.pSangatBaik, kab.pBaik, kab.pCukup],
                    backgroundColor:  "rgb(255, 99, 1)"
                },
                {
                    label: 'Provinsi',
                    data: [prov.pSangatBaik, prov.pBaik, prov.pCukup],
                    backgroundColor: "rgb(54, 162, 235)"
                },                
            ];

            this.setState({
                title: kab.aspek,
                datasets: arrData,
            })

        } 
    }

    render() {        
        const option = {
            legend: { position: 'bottom' },
            title: {
                display: true,
                text: this.state.title
            },
            scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      stacked: true,
                      steps: 10,
                      max: 100
                    },
                  },
                ],
                xAxes: [
                  {
                      display: true,
                  }
                ]
            },
            responsive: false,
            maintainAspectRatio: true,        
        }
        return(
            <Bar
                data={{
                    labels: this.state.labels,
                    datasets: this.state.datasets
                }}
                options = {option}
                width={300} height={240}
            />
        )
    }
}

export default GraphBarSvKarakter;